import React, { useEffect, useState } from 'react';

import { Col, Row } from 'antd/lib/grid';
import { Job, getCore } from 'cvat-core-wrapper';
import { useDispatch, useSelector } from 'react-redux';
import { getJobsAsync } from 'actions/jobs-actions';
import { CombinedState } from 'reducers';
import notification from 'antd/lib/notification';
import UsersComponent from './user';
import JobsComponent from './job';

function AssignmentPageComponent(): JSX.Element {
    const core = getCore();
    const [users, setUsers] = useState<any[]>([]);
    const [submissions, setSubmissions] = useState<any[]>([]);
    const dispatch = useDispatch();
    useEffect(() => {
        core.users.get({}).then((result: any[]) => {
            if (result) {
                setUsers(result);
            }
        });

        core.users.getSubmissions({}).then((result: any[]) => {
            if (result) {
                setSubmissions(result);
            }
        });
        dispatch(getJobsAsync({}, true));
    }, []);
    const [assigning, setAssigning] = useState(false);

    const onJobsUpdate = async (jobs: Job[]): Promise<void> => {
        setAssigning(true);
        let index = 0;
        const { length } = jobs;
        // Queue size controls the number of parallel save requests to prevent database lockups and timeouts.
        const queueSize = 5;
        const failedJobs: { id: number; error: any }[] = [];

        const promises = Array(queueSize)
            .fill(undefined)
            .map(async (): Promise<void> => {
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    const currentIndex = index;
                    index++;
                    if (currentIndex >= length) break;

                    const job = jobs[currentIndex];
                    try {
                        await job.save();
                    } catch (err: any) {
                        failedJobs.push({ id: job.id, error: err });
                    }
                }
            });
        await Promise.allSettled(promises);

        if (failedJobs.length > 0) {
            const failedIds = failedJobs.map((f) => f.id).join(', ');
            notification.error({
                message: 'Assignment Error',
                description: `Failed to save changes for Job ID(s): ${failedIds}. Please try assigning them again.`,
                duration: 10,
            });
        }

        dispatch(getJobsAsync({}, true));
        setAssigning(false);
    };

    const fetching = useSelector((state: CombinedState) => state.jobs.fetching);
    const count = useSelector((state: CombinedState) => state.jobs.count);
    const jobs = useSelector((state: CombinedState) => state.jobs.current);

    return (
        <>
            <Row>
                <Col sm={12}>
                    <JobsComponent
                        users={users}
                        submissions={submissions}
                        jobs={jobs}
                        count={count}
                        onJobsUpdate={onJobsUpdate}
                        fetching={fetching || assigning}
                    />
                </Col>
                {/* <Col sm={1}>
                    <Divider type={'vertical'} style={{ height: '100%' }}></Divider>
                </Col> */}
                <Col sm={12}>
                    <UsersComponent
                        users={users}
                        submissions={submissions}
                        jobs={jobs}
                        count={count}
                        fetching={fetching}
                    />
                </Col>
            </Row>
        </>
    );
}

export default React.memo(AssignmentPageComponent);
